var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.Utilities = OCS.Classes.Utilities || {};
OCS.Functions = OCS.Functions || {};
OCS.Functions.define_base_utilities = function () {
     return new Class(OCS.Interfaces.Utilities.base);
};
OCS.Classes.Utilities.base = OCS.Functions.define_base_utilities();